import { FC } from "react";
import {
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import { Organization } from "@common/types/organization";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useRemoveClientMutation } from "@api/organizationClient.api";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import actionsStyles from "../../ClientActions.module.scss";
import styles from "../ClientRemoval.module.scss";
import { ClientDetailsRow } from "../../views/clientViewConfig";

interface Props {
    client: ClientDetailsRow;
    onClose: () => void;
}

export const RemoveClientModal: FC<Props> = ({ client, onClose }) => {
    const { toast } = useToaster();
    const activeOrganization = useActiveOrganization() as Organization;
    const removeClientMutation = useRemoveClientMutation();

    const handleRemoveClient = async () => {
        await removeClientMutation.mutateAsync({
            clientId: client.id,
            organizationId: activeOrganization.id,
        });
        toast("Client removed");
        onClose();
    };

    return (
        <>
            <StandardModalHeader className={actionsStyles.modalHeader}>
                Remove client?
            </StandardModalHeader>
            <StandardModalBody className={actionsStyles.modalBody}>
                <section>
                    <p>
                        This action cannot be undone. You'll lose access to
                        their workspace and books.
                    </p>
                </section>

                <footer className={styles.footer}>
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={onClose}
                        size="xl"
                        disabled={removeClientMutation.isPending}
                    >
                        Cancel
                    </Button>
                    <ButtonWithLoader
                        onClick={handleRemoveClient}
                        loading={removeClientMutation.isPending}
                        variant="primary"
                        size="xl"
                    >
                        Yes, remove
                    </ButtonWithLoader>
                </footer>
            </StandardModalBody>
        </>
    );
};
